module.exports = __webpack_public_path__ + "static/media/gateau.911c784c.svg";